
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".5","fill":"#000"}},[_c('path',{attrs:{"d":"M1.02 22.74l5.296-1.186h.044a1.892 1.892 0 001.338-.557L22.205 6.501a1.92 1.92 0 000-2.709L18.978.56a1.922 1.922 0 00-2.711 0L1.75 15.064a1.853 1.853 0 00-.54 1.36L.018 21.741a.835.835 0 00.37.891.855.855 0 00.634.112M17.107 1.4a.73.73 0 011.029 0l3.227 3.233a.707.707 0 01.215.511.726.726 0 01-.215.516l-1.398 1.397-4.26-4.256L17.107 1.4zM2.982 15.514L14.863 3.64l4.26 4.256-11.88 11.875-4.26-4.257zm-1.151 3.6l.561-2.507 3.768 3.765-2.695.601-1.634-1.86z"}}),_c('path',{attrs:{"d":"M6.51 16.842a.582.582 0 01-.419-.175.596.596 0 010-.84l9.045-9.038a.589.589 0 01.841 0 .596.596 0 010 .841l-9.044 9.037a.591.591 0 01-.423.175z"}})])])
          )
        }
      }
    